import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useContext } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/pager.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { PAGER_ELEMS } from '../types.js';
import { PAGER_ARROW_SIDES } from './types.js';
import { PagerContext } from '../pager-context.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var bem = HoneyBem.init('pager', styles);
var PagerArrow = function (_a) {
  var _b;
  var href = _a.href,
    side = _a.side,
    Elem = _a.Elem,
    extraClasses = _a.extraClasses,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c,
    rest = __rest(_a, ["href", "side", "Elem", "extraClasses", "disabled"]);
  var PagerElem = useContext(PagerContext).PagerElem;
  var ItemElem = Elem || PagerElem;
  var computedHref = ItemElem === 'a' ? href : undefined;
  return /*#__PURE__*/React__default__default.createElement("li", {
    className: bem.e('item', {}, extraClasses)
  }, /*#__PURE__*/React__default__default.createElement(ItemElem, __assign({
    className: bem.e('link', (_b = {}, _b[side] = true, _b.disabled = disabled, _b))
  }, computedHref && {
    href: computedHref
  }, disabled && {
    'aria-disabled': true
  }, rest)));
};
PagerArrow.displayName = 'PagerArrow';
PagerArrow.propTypes = {
  side: PropTypes__default.oneOf(PAGER_ARROW_SIDES).isRequired,
  Elem: PropTypes__default.oneOf(PAGER_ELEMS),
  'aria-label': PropTypes__default.string.isRequired,
  disabled: PropTypes__default.bool,
  extraClasses: PropTypes__default.string
};
var pagerArrow = Injecss(PagerArrow, styles);

export { PagerArrow, pagerArrow as default };
